export default {
  // 搜索选择器
  transactionDirection: "交易方向",
  currency: "币种",
  pleaseSelect: "请选择",
  transactionAmount: "交易数量",
  transactionCount: "交易次数",
  minAmount: "最小数量",
  maxAmount: "最大数量",
  maxAmountWarning: "最大数量需≥最小数量",

  // 按钮
  reset: "重置",
  query: "查询",

  // 数据统计
  totalData: "共计{count}条数据",

  // 加载
  loading: "拼命加载中",

  // 表格列
  direction: "交易方向",
  count: "交易次数",
  currencyName: "币种",
  totalAmount: "交易总数量",

  // 交易方向
  buy: "买入",
  sell: "卖出",
  unknown: "未知",

  // 空状态
  noOtcData: "当前调证文件中未解析到OTC交易数据",

  // 下载
  downloadDetails: "下载数据明细",
};
